// TODO: refactor into nth icon module
import React, { CSSProperties, FC } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './Link.module.css';

export interface LinkIconProps {
  s?: CSSProperties;
  ariaTitle?: string;
}

const LinkIcon: FC<LinkIconProps> = ({ s = {}, ariaTitle }) => {
  const { iconsPrimaryNone: linkIconStyle } = useTheme();
  const style = { ...linkIconStyle, ...s };

  return (
    <svg
      role="img"
      className={styles.container}
      style={{ fill: style.color, ...style }}
      viewBox="0 0 18 18"
    >
      {ariaTitle && <title>{ariaTitle}</title>}
      <path d="M4.07238 7.8136L2.01474 9.87124C0.257385 11.6286 0.257385 14.4778 2.01474 16.2352C3.7721 17.9926 6.62135 17.9926 8.37871 16.2352L11.1213 13.4926C12.8787 11.7352 12.8787 8.88596 11.1213 7.1286C10.7494 6.7567 10.3286 6.4635 9.87963 6.249L9.00002 7.1286C8.90856 7.22007 8.83137 7.32041 8.76847 7.42686C9.24162 7.56243 9.68799 7.81657 10.0607 8.18926C11.2323 9.36083 11.2323 11.2603 10.0607 12.4319L7.31804 15.1745C6.14647 16.3461 4.24698 16.3461 3.0754 15.1745C1.90383 14.003 1.90383 12.1035 3.0754 10.9319L4.26431 9.74299C4.09602 9.11281 4.03205 8.46056 4.07238 7.8136Z" />
      <path d="M6.87871 5.00728C5.12135 6.76464 5.12135 9.61388 6.87871 11.3712C7.25061 11.7431 7.67142 12.0363 8.12043 12.2508L9.28382 11.0874C8.79131 10.9559 8.32575 10.697 7.93937 10.3106C6.76779 9.13901 6.76779 7.23952 7.93936 6.06794L10.682 3.3253C11.8536 2.15373 13.7531 2.15373 14.9246 3.3253C16.0962 4.49687 16.0962 6.39637 14.9246 7.56794L13.7357 8.75685C13.904 9.38704 13.968 10.0393 13.9277 10.6862L15.9853 8.6286C17.7427 6.87124 17.7427 4.022 15.9853 2.26464C14.2279 0.507281 11.3787 0.507281 9.62135 2.26464L6.87871 5.00728Z" />
    </svg>
  );
};

export default LinkIcon;
